import ReactDOM from 'react-dom';
//import Bootstrap from 'bootstrap/dist/css/bootstrap.css';
import './styles/App.scss';
import './styles/config.scss';
import './styles/LandingPage.scss';
import './libs/fullstoryShare.js';

import App from './components/app';
import {Provider} from 'react-redux';
import store from './redux/store'

import 'react-app-polyfill/ie9';

ReactDOM.render(
    <Provider store={store}>
        <App/>
    </Provider>, document.getElementById('root'));
